import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { ROUTES } from "~/router";
import { ROLES, User } from "~/shared.types";
import { useAuthStore, useUserStore } from "~/stores";
import { useRedirect } from "./navigation";

export const useResolveRedirection = (user?: User) => {
  const redirect = useRedirect();
  const redirectFromStore = useAuthStore((state) => state.redirectTo);
  const userRole = useUserStore((store) => store.role);
  const [searchParams] = useSearchParams();

  const redirectFromQuery = searchParams.get("redirect");
  const redirectTo = redirectFromQuery || redirectFromStore;
  const clientId = searchParams.get("client_id");
  const redirectUri = searchParams.get("redirect_uri");
  const state = searchParams.get("state");
  const responseType = searchParams.get("response_type");
  const scope = searchParams.get("scope");

  const comesFromMightyNetworks = clientId && redirectUri && state;

  useEffect(() => {
    if (comesFromMightyNetworks) {
      if (redirectTo) {
        redirect(redirectTo);
        return;
      }

      if (user || userRole) {
        window.location.href = `/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&response_type=${responseType}&scope=${scope}`;
        return;
      }
    }

    if (user && (user.userType || userRole)) {
      const role = user.userType ?? userRole;
      if (role === ROLES.USER.value) {
        const redirectPath = redirectTo || ROUTES.hubHome;
        redirect(redirectPath);
        return;
      }

      redirect(ROUTES.dashboard);
    }
  }, [redirectTo, user, redirect, userRole]);
};
